/* eslint-disable @typescript-eslint/naming-convention -- graphcache exchange schema uses GraphQL type names. */
const invalidateCourseFoldersQueries = (cache: {
  inspectFields: (
    entity: string,
  ) => { fieldName: string; fieldKey: string }[];
  invalidate: (entity: string, fieldKey: string) => void;
}): void => {
  cache
    .inspectFields('Query')
    .filter((field) => field.fieldName === 'courseFolders')
    .forEach((field) => {
      cache.invalidate('Query', field.fieldKey);
    });
};

export const courseMaterialFoldersCacheExchange = {
  updates: {
    Mutation: {
      updateMaterial(
        _result: unknown,
        _args: unknown,
        cache: Parameters<typeof invalidateCourseFoldersQueries>[0],
      ) {
        invalidateCourseFoldersQueries(cache);
      },
      createCourseMaterial(
        _result: unknown,
        _args: unknown,
        cache: Parameters<typeof invalidateCourseFoldersQueries>[0],
      ) {
        invalidateCourseFoldersQueries(cache);
      },
      removeMaterial(
        _result: unknown,
        _args: unknown,
        cache: Parameters<typeof invalidateCourseFoldersQueries>[0],
      ) {
        invalidateCourseFoldersQueries(cache);
      },
    },
  },
};
